export default "__VITE_ASSET__DIBLsOLI__"